export default {
  header: {
    review_us: 'Arvostele meidät Googlessa',
    upload: 'Lataa Google-arvostelu',
    not_now: 'Ei nyt',
  },
  steps: {
    how_it_works: 'Näin se toimii',
    step_1: {
      title: 'Vaihe',
      description: 'Kirjoita arvostelu kohteesta {{name}} Googleen',
    },
    step_2: {
      title: 'Vaihe',
      description: 'Lataa kuvakaappaus julkaisemastasi arvostelusta (katso esimerkki alla)',
    },
  },
  buttons: {
    upload_screenshot: 'Lataa kuvakaappaus',
    leave_google_review: 'Jätä Google-arvostelu',
    submit_screenshot: 'Lähetä kuvakaappaus',
    return: 'Takaisin',
  },
  enter_name: {
    title: 'Nimi, jolla arvostelusi julkaistiin',
    place_holder: 'Syötä nimi',
  },
  screenshot_uploaded: {
    title: 'Kuvakaappaus ladattu',
    description: 'Vieritä alas nähdäksesi koko kuvakaappauksen',
  },
  loading: {
    processing: 'Julkaisemasi arvostelu on tarkistettavana',
  },
  error_messages: {
    upload_failed: 'Kuvakaappauksen lataaminen epäonnistui. Yritä uudelleen.',
    review_already_uploaded:
      'Näyttää siltä, että olet jo ladannut kuvakaappauksen Google-arvostelusta. Google-arvostelusta voi saada palkinnon vain kerran 😊',
    name_missing: {
      description: 'Syötä nimi, jolla arvostelusi julkaistiin, jotta voimme yhdistää tietosi.',
      button: {
        title: 'Selvä',
      },
    },
  },
};
